import { DbRef } from "./firebase";
export var LateCheckInReason;
(function (LateCheckInReason) {
    LateCheckInReason["BAD_RECEPTION"] = "badReception";
    LateCheckInReason["NO_ACCESS_TO_SUPPLIES"] = "noAccessToSupplies";
    LateCheckInReason["SUPPLY_SHORTAGE"] = "supplyShortage";
    LateCheckInReason["TECH_ISSUE"] = "techIssue";
    LateCheckInReason["OTHER"] = "other";
})(LateCheckInReason || (LateCheckInReason = {}));
export const lateCheckInReasonLabels = {
    [LateCheckInReason.BAD_RECEPTION]: 'Bad reception',
    [LateCheckInReason.NO_ACCESS_TO_SUPPLIES]: 'No access to supplies',
    [LateCheckInReason.SUPPLY_SHORTAGE]: 'Supply shortage',
    [LateCheckInReason.TECH_ISSUE]: 'Tech issue',
    [LateCheckInReason.OTHER]: 'Other',
};
export var ShiftToolName;
(function (ShiftToolName) {
    ShiftToolName["CENTRIFUGE"] = "centrifuge";
})(ShiftToolName || (ShiftToolName = {}));
/** Status of the performance evaluation as a whole */
export var ShiftPerformanceStatus;
(function (ShiftPerformanceStatus) {
    /** Shift status is not Complete or Failed */
    ShiftPerformanceStatus["PENDING"] = "pending";
    /** No performance metric evaluations flagged as issues or any issues were manually validated */
    ShiftPerformanceStatus["REVIEWED"] = "reviewed";
    /** Performance metric evaluations were flagged and performance must be manually validated */
    ShiftPerformanceStatus["NEEDS_REVIEW"] = "needsReview";
})(ShiftPerformanceStatus || (ShiftPerformanceStatus = {}));
export var ShiftPerformanceMetricStatus;
(function (ShiftPerformanceMetricStatus) {
    /** No issues were flagged */
    ShiftPerformanceMetricStatus["PASS"] = "pass";
    /** This metric was flagged as an issue */
    ShiftPerformanceMetricStatus["FAIL"] = "fail";
    /** Performance status as a whole has not been evaluated yet */
    ShiftPerformanceMetricStatus["PENDING"] = "pending";
})(ShiftPerformanceMetricStatus || (ShiftPerformanceMetricStatus = {}));
export var ShiftPerformanceMetricName;
(function (ShiftPerformanceMetricName) {
    /** The timeliness of arrival to the patient */
    ShiftPerformanceMetricName["PATIENT_PUNCTUALITY"] = "patientPunctuality";
    /** The success of the procedure */
    ShiftPerformanceMetricName["PROCEDURE_SUCCESS"] = "procedureSuccess";
    /** The timeliness of any drop offs */
    ShiftPerformanceMetricName["DROP_OFF_PUNCTUALITY"] = "dropOffPunctuality";
    /** The success of the processing, i.e did the lab reject any samples */
    ShiftPerformanceMetricName["PROCESSING_SUCCESS"] = "processingSuccess";
})(ShiftPerformanceMetricName || (ShiftPerformanceMetricName = {}));
export const ShiftRelationshipKeys = {
    nursesOffered: { ref: DbRef.USERS },
    itineraries: { ref: DbRef.ITINERARIES },
    serviceRegions: { ref: DbRef.SERVICE_REGIONS },
    supplyItems: { ref: DbRef.SUPPLY_ITEMS },
    staffingOffices: { ref: DbRef.OFFICES },
    taskIDs: { ref: DbRef.TASKS },
    userID: { ref: DbRef.USERS },
    products: { ref: DbRef.PRODUCTS },
};
/**
 * If a shift is automatically set to failed a reason will be given. There
 * may be multiple criteria that would prevent the shift being set to complete,
 * but only this first one encountered will be stored.
 */
export var ShiftFailureReason;
(function (ShiftFailureReason) {
    /** Shift status not `inProgress` at end of shift. */
    ShiftFailureReason["INCOMPLETE_SHIFT_CHECK_IN"] = "incompleteShiftCheckIn";
    /**
     * Shift geo-check notification sent (`Shift.geoCheck` exists), but geo-check
     * not completed (`Shift.geoCheck.completedAt` does not exist.)
     */
    ShiftFailureReason["INCOMPLETE_GEO_CHECK"] = "incompleteGeoCheck";
    /**
     * One of more non-cancelled itineraries on the shift do not have status
     * `completed`. First affected itinerary ID will be stored in `relatedID`.
     */
    ShiftFailureReason["INCOMPLETE_ITINERARY"] = "incompleteItinerary";
})(ShiftFailureReason || (ShiftFailureReason = {}));
export var ShiftStatus;
(function (ShiftStatus) {
    /**
     * A nurse has been assigned to a shift
     */
    ShiftStatus["ACCEPTED"] = "accepted";
    /**
     * Blocked availability. Not to represent the lifecycle of a shift, but to
     * represent a prior reservation
     */
    ShiftStatus["BLOCKING"] = "blocking";
    /**
     * The shift was canceled
     */
    ShiftStatus["CANCELED"] = "canceled";
    /**
     * Check in has been completed
     */
    ShiftStatus["IN_PROGRESS"] = "inProgress";
    /**
     * Shift is created and awaiting assignment
     */
    ShiftStatus["PENDING"] = "pending";
    /**
     * Shifts will be automatically set to completed at their set end time if
     * they meet specified criteria. Otherwise they may be manually set to
     * completed in Dashboard.
     *
     * When an unpaid shift is set to completed, a shift payment transaction will
     * be added to the clinician’s balance.
     */
    ShiftStatus["COMPLETE"] = "complete";
    /**
     * Shifts will be automatically set to failed at their set end time if
     * they meet specified criteria.
     */
    ShiftStatus["FAILED"] = "failed";
})(ShiftStatus || (ShiftStatus = {}));
export var ShiftOfferStatus;
(function (ShiftOfferStatus) {
    ShiftOfferStatus["ACCEPTED"] = "accepted";
    ShiftOfferStatus["CANCELED"] = "canceled";
    ShiftOfferStatus["DECLINED"] = "declined";
    ShiftOfferStatus["NO_RESPONSE"] = "noResponse";
})(ShiftOfferStatus || (ShiftOfferStatus = {}));
export var ShiftOfferCancelReason;
(function (ShiftOfferCancelReason) {
    ShiftOfferCancelReason["CHANGE_IN_SCHEDULE"] = "changeInSchedule";
    ShiftOfferCancelReason["CONFLICTING_JOB_OFFER"] = "conflictingJobOffer";
    ShiftOfferCancelReason["SUPPLY_MALFUNCTION"] = "supplyMalfunction";
})(ShiftOfferCancelReason || (ShiftOfferCancelReason = {}));
export const shiftOfferCancelReasonLabels = {
    [ShiftOfferCancelReason.CHANGE_IN_SCHEDULE]: 'Change in schedule',
    [ShiftOfferCancelReason.CONFLICTING_JOB_OFFER]: 'Conflicting job offer',
    [ShiftOfferCancelReason.SUPPLY_MALFUNCTION]: 'Supply malfunction',
};
//# sourceMappingURL=shift.js.map